import React, { Component } from "react";
import { connect } from "react-redux";
import { getSpk } from "../../../../../Redux/reducer/env";
import ReactTooltip from "react-tooltip";
import PropTypes from "prop-types";
import StepControl from "./stepControl";
import Modal from "../../../../utils/customModal";
import { errorContainer, loadingHtml } from "../../../../utils/functions";
import LockIcon from "../../../../../../static/images/lock-icon.svg";
import CloseIcon from "../../../../../../static/images/close-icon.svg";
import ShowIcon from "../../../../../../static/images/show-icon.svg";
import ErrorIcon from "../../../../../../static/images/error-icon.svg";

export class Step2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        secretWord: "",
        confirmSecretWord: "",
        hideWord: true,
        hideConfWord: true,
      },
      errors: {
        secretWord: "",
      },
      modal: {
        show: false,
        type: "loading",
        modalMessage: { title: "", message: "" },
      },
    };
  }

  componentDidMount() {
    var { user } = this.state;
    user.secretWord = this.props.user.secretWord;
    user.confirmSecretWord = this.props.user.confirmSecretWord;
    this.setState({ user });
  }

  handlerChange(event) {
    const user = this.state.user;
    user[event.target.name] = event.target.value;

    this.setState({ user });
  }

  clear(event, element) {
    event.preventDefault();
    const user = this.state.user;
    user[element] = "";

    // Estamos limpiando una contraseña
    if (element.indexOf("password") != -1) {
      switch (element) {
        case "password":
          user.hidePassword = true;
          break;
        case "confirm_password":
          user.hideConsPass = true;
          break;
      }
    }

    this.setState({ user });
  }

  closeModal = () => {
    const { modal } = this.state;
    modal.show = false;
    modal.type = "loading";
    modal.modalMessage = { title: "", message: "" };
    this.setState({ modal });
  };

  getModalContent = () => {
    const { type, modalMessage } = this.state.modal;

    switch (type) {
      case "loading":
        return loadingHtml();
      case "error":
        return errorContainer(
          modalMessage.title,
          modalMessage.message,
          this.closeModal
        );
    }
  };

  closeButton(element) {
    return this.state.user[element] != "" ? (
      <div
        className="button-auto input-w-aux__action clear-user"
        onClick={(event) => this.clear(event, element)}
      >
        <img src={CloseIcon} alt={`limpiar`} />
      </div>
    ) : null;
  }

  showInput(event, element) {
    event.preventDefault();
    const { user } = this.state;

    switch (element) {
      case "secretWord":
        user.hideWord = !user.hideWord;
        this.setState({ user });
        break;
      case "confirmSecretWord":
        user.hideConfWord = !user.hideConfWord;
        this.setState({ user });
        break;
    }
  }

  showPass(element) {
    return this.state.user[element] != "" ? (
      <div
        className="button-auto input-w-aux__action show-password"
        onClick={(event) => this.showInput(event, element)}
      >
        <img src={ShowIcon} alt={`limpiar`} />
      </div>
    ) : null;
  }

  validatePassword() {
    const { user, errors } = this.state;
    var regexp = new RegExp(/^[a-zA-Z\d]{8,32}$/);
    var result = regexp.test(user.secretWord);
    if (result) {
      if (user.secretWord == user.confirmSecretWord) {
        return true;
      } else {
        errors.secretWord = "Las palabras secretas no coinciden";

        this.setState({ errors });
        this.inputErrors("secretWord", true);

        return false;
      }
    } else {
      // La palabra secreta no coincide con el patrón
      errors.secretWord = "La palabra secreta no coincide con el patrón";

      this.setState({ errors });
      this.inputErrors("secretWord", true);

      return false;
    }
  }

  submitForm(e) {
    e?.preventDefault();
    // Validamos la contraseña
    const { user, errors } = this.state;
    if (user.secretWord != "" && user.confirmSecretWord != "") {
      if (this.validatePassword()) {
        const { modal } = this.state;

        modal.show = true;
        this.setState({ modal });

        this.props.submitStep(true, {
          secretWord: user.secretWord,
          confirmSecretWord: user.confirmSecretWord,
        });
      }
    } else {
      if (user.secretWord == "") {
        errors.secretWord = "Debe completar este campo";
      }
      if (user.confirmSecretWord == "") {
        errors.confirmSecretWord = "Debe completar este campo";
      }
      this.setState({ errors });
    }
  }

  inputErrors(id, hasFocus = false) {
    document.getElementById(id)?.classList.add("input--error");
    if (hasFocus) {
      document.getElementById(id).focus();
    }
  }

  displayError(id) {
    const { errors } = this.state;

    return errors[id] != "" ? (
      <div id="select-2-error" className="error">
        <span className="error__icon">
          <img src={ErrorIcon} alt="Error" />
        </span>
        <div className="error__text">{errors[id]}</div>
      </div>
    ) : null;
  }

  render() {
    const { modal } = this.state;
    return (
      <div id="step-2">
        <div className="user-credentials">
          <h1>Defina una palabra secreta</h1>
          <div className="login-form">
            <form
              action="post"
              className="login"
              onSubmit={(e) => this.submitForm(e)}
            >
              <div className="input-w-aux">
                <img
                  className="button input-w-aux__icon"
                  src={LockIcon}
                  alt={`Contraseña`}
                />
                <input
                  id="secretWord"
                  name="secretWord"
                  className="input input--text input-w-aux__input input--active"
                  type={this.state.user.hideWord ? "password" : "text"}
                  placeholder={`Palabra secreta`}
                  autoComplete="off"
                  value={this.state.user.secretWord}
                  onChange={(event) => this.handlerChange(event)}
                  data-tip
                  data-for="secret-word-tooltip"
                />
                {this.closeButton("secretWord")}
                {this.showPass("secretWord")}
                <ReactTooltip
                  id="secret-word-tooltip"
                  className="info-tooltip"
                  type="light"
                  effect="solid"
                  place="right"
                  offset={{ top: 0 }}
                  event="focus"
                  eventOff="focusout"
                >
                  <div className="tooltip-content">
                    <p>La palabra secreta debe contener:</p>
                    <ul>
                      <li>De 8 a 32 caracteres alfanuméricos de largo.</li>
                      <li>No se permiten caracteres especiales (ej: !$%&).</li>
                      <li>No se aceptan espacios.</li>
                    </ul>
                  </div>
                </ReactTooltip>
                {this.displayError("secretWord")}
              </div>
              <div className="input-w-aux">
                <img
                  className="button input-w-aux__icon"
                  src={LockIcon}
                  alt={`Contraseña`}
                />
                <input
                  id="password"
                  name="confirmSecretWord"
                  className="input input--text input-w-aux__input input--active"
                  type={this.state.user.hideConfWord ? "password" : "text"}
                  placeholder={`Confirmar palabra secreta`}
                  autoComplete="off"
                  value={this.state.user.confirmSecretWord}
                  onChange={(event) => this.handlerChange(event)}
                  data-tip
                  data-for="password-disclaimer"
                />
                {this.closeButton("confirmSecretWord")}
                {this.showPass("confirmSecretWord")}
              </div>
              <StepControl
                currentStep={2}
                submitStep={(e) => this.submitForm(e)}
                goBack={() => this.props.submitStep(false)}
              />
            </form>
          </div>
        </div>
        <Modal
          key={`provider-users`}
          show={modal.show}
          hideClose={modal.type == "loading"}
          handleClose={() => this.closeModal()}
        >
          {this.getModalContent()}
        </Modal>
      </div>
    );
  }
}

Step2.propTypes = {
  submitStep: PropTypes.func.isRequired,
};

export const mapStateToProps = (state) => {
  return {
    spk: getSpk(state),
    registerInfo: state.sessionInfoReducer.registerInfo,
  };
};

export default connect(mapStateToProps, null)(Step2);
